import * as angular from 'angular';

export class StringParsersService {

    constructor() {
    }

    removeAccents(str: string) {
        if (str) {
            let strAccentsOut = [];
            let accents = 'ĄąĆćĘęŁłŃńÓóŚśŹźŻż';
            let accentsOut = 'AaCcEeLlNnOoSsZzZz';
            let arr = str.split('');
            for (let i = 0; i < arr.length; i++) {
                if (accents.indexOf(arr[i]) != -1) {
                    strAccentsOut[i] = accentsOut.substr(
                        accents.indexOf(arr[i]),
                        1
                    );
                } else {
                    strAccentsOut[i] = arr[i];
                }
            }
            return strAccentsOut.join('');
        }
    }
}

angular
    .module('app')
    .service('StringParsersService', StringParsersService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/string-parsers.service.ts